<span *ngIf="haveChildren()" (click)="toggle()" class="bz-icon-toggle">{{getExpandedIcon()}}</span>

<div class="container-check">
    <label class="container" *ngIf="node.hasCheckbox">
        <input type="checkbox"  [checked]="node.isChecked" [disabled]="!node.isEnable" (change)="onCheck()" *ngIf="node.hasCheckbox">
        <span [class]="!node.isEnable ? 'checkmark check-disabled': node.isPartial ? 'checkmark_partial' : 'checkmark'" *ngIf="node.hasCheckbox"></span>
    </label>
</div>

<span [title]="node.displayName" [ngClass]="{'disabled': !node.isEnable}"
    (click)="toggle()"
    class="bz-attr-type-value">   
    <bzg-icon class="bz-trace-node-list-nodes__node__icon bz-space--inline-s" color="warning" [nameIcon]="node.icon"></bzg-icon>
    <a >{{node.displayName}}</a>
</span>

<treeview *ngIf="haveChildren() && node.isExpanded"
        [nodes]="node.nodes"
        (itemSelected) = "onEmitCheck()"
        (selectedNode)= "onSelectedNode($event)">
</treeview>
